import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';

const FilterButtons = ({ data, handlerChange, previousSelectedStatus }) => {
  const [selected, setSelected] = useState(previousSelectedStatus || '');

  const handleClick = status => {
    setSelected(status);
    handlerChange(status);
  };

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="d-flex flex-row">
              <div className="p-2">
                <Button
                  color="primary"
                  outline={selected !== ''}
                  onClick={() => handleClick('')}
                >
                  All
                </Button>
              </div>
              {Object.keys(data).map(status => (
                <div className="p-2" key={status}>
                  <Button
                    color="primary"
                    outline={selected !== status}
                    onClick={() => handleClick(status)}
                  >
                    {data[status]}
                  </Button>
                </div>
              ))}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

FilterButtons.propTypes = {
  data: PropTypes.object.isRequired,
  handlerChange: PropTypes.func.isRequired,
};

export default FilterButtons;
